import { useEffect } from 'react';
import { clickEvent } from '../track/trackingEvent/clickEvent';
import { allButtonsSelector } from '../track/utils/allButtonsSelector';
import { DATA_TRACKING_PLACEMENT } from '../track/utils/getTrackingAttributes';
import {
  DATA_LOCALE,
  DATA_MODEL,
  DATA_SLUG,
} from '../track/utils/getBodyAttributes';
import { scrollEvent } from '../track/trackingEvent/scrollEvent';
import { pageView } from '../track/trackingEvent/pageview';

export interface TrackingData {
  typeName: string | null;
  slug: string | null;
  locale: string | null;
  headersLinks: HTMLElement[];
}

export const useTracking = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined')
      return;
    const typeName = document.body.getAttribute(DATA_MODEL);
    const slug = document.body.getAttribute(DATA_SLUG);
    const locale = document.body.getAttribute(DATA_LOCALE);
    const headers = document.querySelectorAll(
      `[${DATA_TRACKING_PLACEMENT}="header"]`,
    );
    const headersLinks: HTMLElement[] = [];
    headers.forEach((header) => {
      const links = header.querySelectorAll(
        allButtonsSelector,
      ) as NodeListOf<HTMLElement>;
      headersLinks.push(...Array.from(links));
    });

    const trackingData: TrackingData = {
      typeName,
      slug,
      locale,
      headersLinks,
    };

    pageView(trackingData);
    const destroyClickEvent = clickEvent();
    const destroyScrollEvent = scrollEvent();

    return () => {
      destroyClickEvent();
      destroyScrollEvent();
    };
  }, []);
};
